import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

import { Col, Row } from "reactstrap";
import Layout from "../../components/Layout/Layout";

import useDynamicComponent from "../../components/dynamics/useDynamicComponent";
import ButtonComponent from "../../components/ButtonComponent";
import Routes from "../../helpers/Routes";

export default function ClientIndex() {
    const MainContent = useDynamicComponent("ClientIndex");

    //Declaração de outros estados e variáveis importantes
    const navigate = useNavigate();

    const onNewTaskClick = () => {
        navigate(Routes.clients.create);
    };

    const intl = useIntl();

    return (
        <Layout>
            <div className="pageContainer">
                <div className="pageHeader">
                    <span className="pageTitle">
                        <FormattedMessage id="Screens.Clients.Title" />
                    </span>
                </div>

                <Row>
                    <Col
                        xl={2}
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                        style={{ marginTop: "1em" }}
                    >
                        <ButtonComponent
                            text={intl.formatMessage({ id: "Screens.Client.Button.CreateClient" })}
                            onClick={onNewTaskClick} />
                    </Col>
                </Row>

                <div className="pageBody">{MainContent}</div>
            </div>
        </Layout>
    );
}
